define(["jquery", "jquery-validate", "jquery-validate-unobtrusive", "jquery-unobtrusive-ajax"], function() {});